module.exports = __webpack_public_path__ + "static/img/歷史師資介紹.e6723aa6.png";